const r = "_error_xmn13_1", e = {
  error: r
};
export {
  e as default,
  r as error
};
//# sourceMappingURL=error.module.less.js.map
